// « Régénérer » → 3D preview in seconds (2026-10-21, branch preview-speed).
const m: Record<string, string> = {
  'Lancé — l’aperçu 3D se met à jour en quelques secondes, le PDF d’impression suit.': 'Started — the 3D preview updates in a few seconds, the print PDF follows.',
  'Lancé — le PDF puis l’aperçu 3D se refont tout seuls (1 à 3 min).': 'Started — the PDF, then the 3D preview, rebuild on their own (1 to 3 min).',
  'Lancé': 'Started',
  'Aperçu 3D': '3D preview',
  'PDF d’impression': 'Print PDF',
  'arrivera avec le PDF': 'will come with the PDF',
  'à jour ✓': 'up to date ✓',
  'à jour ✓ ({s} s)': 'up to date ✓ ({s} s)',
  '{done}/{total} pages': '{done}/{total} pages',
  'préparation…': 'preparing…',
  'en attente…': 'waiting…',
  'démarrage…': 'starting…',
  'couverture…': 'cover…',
  'avec le PDF': 'with the PDF',
  'en cours ({s} s)': 'running ({s} s)',
  'en file d’attente': 'queued',
  'échec — voir la fiche': 'failed — see the order',
  'prêt ✓': 'ready ✓',
};
export default m;
